import { dispatcher, IEvent } from "@quest/base-core";
import { FreeGameMetersControllerBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class FreeGameMetersControllerGame extends FreeGameMetersControllerBehavior{
    /**
     * override to show win meter when there is no big win 
     * @param evt 
     */
    protected onStartWinTickUp(evt: IEvent): void {
        var _b;
        if (!this.model.getIsFgBigWin()) {
            this.showWinTickUpMeter();
            (_b = this.winValueMeterFg) === null || _b === void 0 ? void 0 : _b.startTick(this.model.getCurrentWinAmt(), this.model.getIsCredits(), false, this.model.getWinMeterTickUpDurationFg(), true, this.tickUpComplete.bind(this));
            dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: this.model.getWinMeterTickUpSoundFg() });
        }
        this.fadeFreeGameBGM();
    }
}